var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShiftManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3926 21.0874H38.6426V38.1149C38.6426 39.1685 38.224 40.1789 37.4791 40.9239C36.7341 41.6689 35.7236 42.0874 34.6701 42.0874H16.3651C15.3115 42.0874 14.3011 41.6689 13.5561 40.9239C12.8111 40.1789 12.3926 39.1685 12.3926 38.1149V21.0874Z",
    fill: "#CB2110"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5025 7H12.4975C10.0136 7 8 9.0136 8 11.4975V16.73C8 19.2139 10.0136 21.2275 12.4975 21.2275H38.5025C40.9864 21.2275 43 19.2139 43 16.73V11.4975C43 9.0136 40.9864 7 38.5025 7Z",
    fill: "#804419"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3675 29.54H23.085C22.7369 29.54 22.403 29.4018 22.1569 29.1556C21.9107 28.9095 21.7725 28.5756 21.7725 28.2275C21.7725 27.8794 21.9107 27.5456 22.1569 27.2995C22.403 27.0533 22.7369 26.915 23.085 26.915H29.3675C29.7156 26.915 30.0494 27.0533 30.2955 27.2995C30.5417 27.5456 30.68 27.8794 30.68 28.2275C30.68 28.5756 30.5417 28.9095 30.2955 29.1556C30.0494 29.4018 29.7156 29.54 29.3675 29.54Z",
    fill: "#FEF8E7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftManagement);
export default __webpack_public_path__ + "static/media/Shift Management.9d74813dd99f89a6b38277103a8589f7.svg";
export { ForwardRef as ReactComponent };